import { createAction, props } from '@ngrx/store';
import { ICompanyModel } from './company-info.models';

export const loadCompany = createAction('[Company] Load Company', props<{ payload: ICompanyModel }>());

export const loadCompanySuccess = createAction('[Company] Load Company Success', props<{ company: ICompanyModel }>());

export const loadCompanyFailure = createAction('[Company] Load Company Failure', props<{ error: string }>());

export const resetCompany = createAction('[Company] Reset');

export const refreshCompany = createAction('[Company] Refresh');
